export const PUT_MAINTENANCE_INFO = 'PUT_MAINTENANCE_INFO';
export default PUT_MAINTENANCE_INFO;
